 <!-- page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top-detail cf">
         <div class="container">
            <div class="ashton-hero-center-detail news cf">
               <div class="red-titel">News</div>
               <div class="ashton-hero-center-new-detail cf">
                  <div class="ashton-hero-center-new-detail-inner cf">
                    <div class="ashton-hero-center-new-box" *ngFor="let news of newsList">
                      <a [routerLink]="['/news-single', news?.slug]">
                        <div class="ashton-hero-center-new-image">
                           <img [src]="news?.thumbnail_image" alt="new-img">
                        </div>
                        <div class="ashton-hero-center-new-content-box">
                          <h3>{{news?.title}}</h3>
                          <p>{{news?.created_at | amDateFormat:'MMM DD, YYYY'}}</p>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="ashton-hero-center-new-btn">
                     <a (click)="getMoreNews()">LOAD MORE</a>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </section><!-- page ends -->